import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { AuthenticationMethodPolicyMicrosoftAuthenticatorSchema } from './model';

export function initAuthenticationMethodsMicrosoftAuthenticatorForm(
    schema: AuthenticationMethodPolicyMicrosoftAuthenticatorSchema,
): FormGroup {
    const includedGroups = schema.properties?.includeTargets?.items?.oneOf || [];
    const includedGroupsFormArray = new FormArray(
        includedGroups.map(
            (group) =>
                new FormGroup({
                    id: new FormControl(group.properties.id.const),
                    authenticationMode: new FormControl(group.properties.authenticationMode?.const || 'any'),
                }),
        ),
    );

    const groupInclusion = includedGroups.some((res) => res?.properties?.id?.const !== 'all_users');

    const featureSettings = schema.properties?.featureSettings?.properties;

    const createFeatureSettingGroup = (settingKey: string): FormGroup => {
        const setting = featureSettings?.[settingKey]?.properties;
        const excludedGroupId =
            setting?.excludeTarget?.properties?.id?.const === '00000000-0000-0000-0000-000000000000'
                ? null
                : setting?.excludeTarget?.properties?.id?.const;

        return new FormGroup({
            state: new FormControl(setting?.state?.const),
            includeTarget: new FormGroup({
                id: new FormControl(setting?.includeTarget?.properties?.id?.const),
            }),
            excludeTarget: new FormGroup({
                id: new FormControl(excludedGroupId),
            }),
        });
    };

    return new FormGroup({
        state: new FormControl(schema.properties?.state?.const),
        isSoftwareOathEnabled: new FormControl(schema.properties?.isSoftwareOathEnabled?.const),

        includeTargets: new FormGroup({
            includedGroups: includedGroupsFormArray,
            groupInclusion: new FormControl(groupInclusion),
        }),

        excludeTargets: new FormControl(
            schema.properties?.excludeTargets?.items?.oneOf?.map((res) => res?.properties?.id?.const) || [],
        ),

        featureSettings: new FormGroup({
            companionAppAllowedState: createFeatureSettingGroup('companionAppAllowedState'),
            displayAppInformationRequiredState: createFeatureSettingGroup('displayAppInformationRequiredState'),
            displayLocationInformationRequiredState: createFeatureSettingGroup(
                'displayLocationInformationRequiredState',
            ),
        }),
    });
}
